import { createSlice } from "@reduxjs/toolkit";
import { getNode, getPredecessorNodes, getShortestPath } from "../../utils";
import { actions as notificationsActions } from "../slices/notifications";
import * as fixtures from "../fixtures";

const selectedGraph = {
  ...fixtures.pentagon,
  sourceNodeId: "1",
};

const getInitialState = () => {
  return {
    ...selectedGraph,
    destinationNodeId: null,
  };
};

const v2Graph = createSlice({
  name: "v2Graph",
  initialState: getInitialState(),
  reducers: {
    reset: (state, action) => {
      return getInitialState();
    },
    visit: (state, action) => {
      const { nodeId } = action.payload;
      const node = getNode(nodeId, state);
      const [shortestPath, predecessorId] = getShortestPath(nodeId, state);
      node.data = { shortestPath, predecessorId };
    },
    highlightPath: (state, action) => {
      let { nodeId: currentNodeId } = action.payload;
      state.destinationNodeId = currentNodeId;
      let currentNode = getNode(currentNodeId, state);
      let predecessorNodeId = currentNode.data.predecessorId;
      while (predecessorNodeId !== "0") {
        const index = state.edges.findIndex(
          (edge) =>
            edge.source === predecessorNodeId && edge.target === currentNodeId
        );
        // console.log(
        //   `found edge ${predecessorNodeId} -> ${currentNodeId} at ${index}`
        // );
        state.edges[index].data.isHighlighted = true;
        const predecessorNode = getNode(predecessorNodeId, state);
        currentNodeId = predecessorNodeId;
        predecessorNodeId = predecessorNode.data.predecessorId;
      }
    },
    clearHighlightedPath: (state, action) => {
      for (const [index, edge] of state.edges.entries()) {
        state.edges[index].data.isHighlighted = false;
        state.destinationNodeId = null;
      }
    },
  },
});

export const actions = {
  reset: () => (dispatch) => dispatch(v2Graph.actions.reset()),
  select:
    ({ nodeId }) =>
    (dispatch, getState) => {
      const { v2Graph: graphState } = getState();
      dispatch(v2Graph.actions.clearHighlightedPath());
      const node = getNode(nodeId, graphState);
      if (node.data.shortestPath !== undefined) {
        return dispatch(v2Graph.actions.highlightPath({ nodeId }));
      }
      const predecessors = getPredecessorNodes(nodeId, graphState);
      for (const predecessor of predecessors) {
        if (predecessor.data.shortestPath === undefined) {
          return dispatch(
            notificationsActions.enqueueSnackbar({
              message: `Node "${node.id}" has unvisited predecessors`,
              options: {
                variant: "warning",
              },
            })
          );
        }
      }
      dispatch(v2Graph.actions.visit({ nodeId }));
      // dispatch(v2Graph.actions.highlightPath({ nodeId }));
    },
};

export default v2Graph.reducer;
